var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 120.03",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 122.88 120.03"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 102.29v-5.33h3.1v-2.55h3.25V63.03h-6.64V55.7h92.96v7.33h-6.64v31.38h3.25v2.55h3.1v5.33H15.25zM64.37 2.18C75.14-5.26 75.94 9.47 86.52.27v15.01c-10.09 9.07-12.26-5.58-22.15 1.86V2.18zM62.85.81v17.52l48.41 24.76v7.81H11.91v-7.8l48.26-24.83V.81h2.68zm50.95 111.86h-.49v-7.38H9.57v7.38h-.49v.02H0v7.34h122.88v-7.34h-9.08v-.02zM37.08 96.96h3.75v-2.55h3.25V63.03H33.83v31.38h3.25v2.55zm22.49 0h3.76v-2.55h3.24V63.03H56.32v31.38h3.25v2.55zm22.48 0h3.76v-2.55h3.25V63.03H78.8v31.38h3.25v2.55z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2d4190"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.7da7999de8c34835882da55730bb8a18.svg";
export { ForwardRef as ReactComponent };